export default __webpack_public_path__ + "static/media/contacts.036f1a86.png";